import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";
const getToken = () => localStorage.getItem("token");

export const getContactSupport = async ({
  offset = 1,
  limit = 10,
  status = "",
} = {}) => {
  return axios.get(`${API_BASE_URL}/admin/support`, {
    params: { offset, limit, status },
    headers: { token: getToken() },
  });
};

export const updateContactSupportStatus = async (id) => {
  return axios.put(
    `${API_BASE_URL}/admin/support/${id}`,
    {},
    {
      headers: { token: getToken() },
    },
  );
};

export const getSurvaySupport = async ({
  page = 1,
  limit = 10,
  search = "",
  logisticsType = "",
} = {}) => {
  return axios.get(`${API_BASE_URL}/admin/survey`, {
    params: { page, limit, search, logisticsType },
    headers: { token: getToken() },
  });
};
